import { useEffect, useState } from "react";
import { Row, Col, Table } from "reactstrap";
import { getElectricityInfo } from "../../../api/api";
import Spinner from "../../../commons/Spinner";
import { formatNumber, formatPower } from "../../../utils/NumberUtils";

const MitsubishiMultimeter = ({ selected, setSelected, deviceArr, deviceId }) => {

    const [pcsData, setPcsData] = useState(null);
    const authToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setPcsData(null);
        setIsLoading(true);
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async (signal) => {
            const data = await getElectricityInfo(authToken, deviceId, selected, signal);
            if (!data || data === null || data.comm_error) {
                setPcsData({
                    device_id: "---",
                    freq: "---",
                    measured_time: "---",
                    power_factor: "---",
                    r_phs_curr: "---",
                    real_power: "---",
                    recv_power: "---",
                    rs_line_volt: "---",
                    s_phs_curr: "---",
                    st_line_volt: "---",
                    t_phs_curr: "---",
                    time: "---",
                    tr_line_volt: "---",
                    trans_power: "---",
                    work_status: "---",
                })
            } else {
                setPcsData(data);
            } setIsLoading(false);
        };
        const interval = setInterval(() => {
            fetchData(signal);
        }, 60000);
        fetchData(signal);
        return () => {
            clearInterval(interval);
            controller.abort();
        };
        //eslint-disable-next-line
    }, [selected]);

    console.log('pcsData', pcsData)

    return (
        <>
            {/* <DeviceInfoNav deviceArr={deviceArr} selected={selected} setSelected={setSelected} /> */}
            {isLoading ? <Spinner /> : <Row>
                <Col md={2} lg={2} sm={2} xl={1} className="col-2 d-flex flex-row justify-content-end arrow-menu h-100">
                    <div>
                        <button
                            className="btn_back"
                            onClick={() => setSelected(null)}
                        >
                            <img src="/img/left.png" alt="leftArrow" className="m-2" />
                        </button>
                    </div>
                    <div className="vl"></div>
                </Col>
                <Col md={10} lg={10} sm={10} xl={11} className="col-9">
                    <Row className="d-flex flex-row mx-1">
                        <div className="dropDown">
                            <select
                                type="select"
                                size="sm"
                                className="btn__dropdown"
                                value={selected.device_id}
                                onChange={(e) => setSelected(deviceArr.filter(el => (el.device_id === e.target.value))[0])}
                            >
                                {(deviceArr.length > 0) && deviceArr.map((el, i) => <option value={el.device_id} key={i} > {el.device_id} </option>)}
                            </select>
                        </div>
                        <div className="batteryBox">
                            <div className="colBorder mmr">
                                <Row className="justify-content-center"><img src="/img/multimeter.png" alt="pv-pcs" className="pv-pcs" />
                                </Row>
                                <Row className="mb-4 mt-4 justify-content-center">
                                    {pcsData !== null && <span className="pcsdata">{pcsData.device_id}</span>}
                                </Row>
                            </div>
                        </div>
                        <Col md={8} sm={8} lg={7} className="individual-battery">
                            <div className="scroll-bar">
                                {(pcsData !== null) && <Table className="power__data">
                                    <tbody>
                                        <tr>
                                            <td>累計受電電力量</td>
                                            <td>{formatPower(pcsData.recv_power, 2)}h</td>
                                        </tr>
                                        <tr>
                                            <td>累計送電電力量</td>
                                            <td>{formatPower(pcsData.trans_power, 2)}h</td>
                                        </tr>
                                        <tr>
                                            <td>有効電力</td>
                                            <td>{formatPower(pcsData.real_power, 2)}</td>
                                        </tr>
                                        <tr>
                                            <td>力率</td>
                                            <td>{formatNumber(pcsData.power_factor, 3)}</td>
                                        </tr>
                                        <tr>
                                            <td>A-B線間電圧</td>
                                            <td>{formatNumber(pcsData.rs_line_volt, 2)}V</td>
                                        </tr>
                                        <tr>
                                            <td>B-C線間電圧</td>
                                            <td>{formatNumber(pcsData.st_line_volt, 2)}V</td>
                                        </tr>
                                        <tr>

                                            <td>C-A線間電圧</td>
                                            <td>{formatNumber(pcsData.tr_line_volt, 2)}V</td>
                                        </tr>
                                        <tr>
                                            <td>A相電流</td>
                                            <td>{formatNumber(pcsData.r_phs_curr, 2)}A</td>
                                        </tr>
                                        <tr>
                                            <td>B相電流</td>
                                            <td>{formatNumber(pcsData.s_phs_curr, 2)}A</td>
                                        </tr>
                                        <tr>
                                            <td>C相電流</td>
                                            <td>{formatNumber(pcsData.t_phs_curr, 2)}A</td>
                                        </tr>
                                    </tbody>
                                </Table>}
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row >}
        </>
    );
};

export default MitsubishiMultimeter;
